import React, { useEffect } from 'react';
import { useSucursalActiva } from '../../context/SucursalActivaContext';

/**
 * Sucursal de un registro nuevo, según la sucursal global del panel lateral:
 *  - "Todas las sucursales" → se elige en un desplegable.
 *  - Sucursal específica (o cajero) → queda fija con esa sucursal, sin opción de cambiarla.
 * `opcional`: permite "Ninguna" (solo cuando se puede elegir).
 */
export default function SucursalCampo({ value, onChange, label = 'Sucursal', opcional = false, permitidas, className, disabled }) {
  const { sucursalId, sucursales, todas, nombreSucursal } = useSucursalActiva();
  const fija = !todas && sucursalId && sucursalId !== 'all';

  // Con una sucursal específica, el registro siempre pertenece a esa sucursal.
  useEffect(() => { if (fija && value !== sucursalId) onChange(sucursalId); }, [fija, sucursalId, value, onChange]);

  if (fija) {
    return <label className={className}>{label}<input value={nombreSucursal} readOnly disabled aria-readonly="true" /></label>;
  }
  const opciones = sucursales.filter((s) => s.activo !== false && (!permitidas || permitidas.includes(s.id)));
  return (
    <label className={className}>{label}
      <select value={value || ''} onChange={(e) => onChange(e.target.value)} required={!opcional} disabled={disabled}>
        {/* "Selecciona sucursal" es solo un texto guía: no se puede elegir ni guardar. */}
        {opcional ? <option value="">— Ninguna —</option> : <option value="" disabled hidden>Selecciona sucursal</option>}
        {opciones.map((s) => <option key={s.id} value={s.id}>{s.nombre}</option>)}
      </select>
    </label>
  );
}
